import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(() => ({
  container: {
    padding: '20px',
    paddingTop: '40px',
    background: '#F7F7F7',
    width: '100%',
    minHeight: 'calc(100vh - 100px)',
    margin: 'auto',
  },
  alertContainer: {
    margin: '0',
    maxWidth: '1680px',
  },
  banner: {
    width: '100%',
    height: '100px',
    marginBottom: '10px',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '10px',
    '& a': {
      display: 'block',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      borderRadius: '10px',
      overflow: 'hidden',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      display: 'block',
      transform: 'scale(1.3)',
      imageRendering: 'high-quality',
      maxWidth: '2560px',
      margin: '0 auto',
    },
    '@media (min-width: 1920px)': {
      '& img': {
        transform: 'scale(1.2)',
      },
    },
    '@media (max-width: 768px)': {
      height: '150px',
    },
    '@media (max-width: 480px)': {
      height: '120px',
      borderRadius: '4px',
    },
  },
  alert: {
    display: 'inline-flex',
    margin: '0 0 20px',
    padding: '19px 16px 19px 21px',
  },
}), { name: 'Dashboard' });

export default useStyles;
